import type { Component } from "vue";

export const routes = [
  {
    path: "/promotion/manage",
    name: "promotion-manager",
    component: (): Promise<Component> => import("./views/PromotionManager.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
  {
    path: "/promotion/:id",
    name: "promotion-editor",
    component: (): Promise<Component> => import("./views/PromotionEditor.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
];
